import api from './api';

// **Analytics Interfaces**
export interface AnalyticsOverview {
  overview: {
    totalSubmissions: number;
    completedSubmissions: number;
    pendingSubmissions: number;
    overdueSubmissions: number;
    totalSuppliers: number;
    activeSuppliers: number;
    totalTemplates: number;
    completionRate: number;
    deletedSubmissions: number;
  };
  trends: Array<{
    date: string;
    sent: number;
    completed: number;
    overdue: number;
    in_progress: number;
  }>;
  templatePerformance: Array<{
    _id: string;
    templateTitle: string;
    templateType: string;
    totalSent: number;
    completed: number;
    completionRate: number;
    avgProgress: number;
    avgCompletionTime: number;
  }>;
  supplierPerformance: Array<{
    _id: string;
    supplierName: string;
    totalSubmissions: number;
    completed: number;
    completionRate: number;
    avgProgress: number;
    lastActivity: string;
  }>;
}

export interface StatusDistribution {
  [status: string]: number;
}

// **API Functions**
export const getAnalyticsOverview = async (params?: {
  year?: number;
  period?: '7d' | '30d' | '90d' | '1y';
}): Promise<{ data: AnalyticsOverview }> => {
  const queryParams = new URLSearchParams();
  if (params?.year) queryParams.append('year', params.year.toString());
  if (params?.period) queryParams.append('period', params.period);
  
  return await api.get(`/analytics/overview?${queryParams.toString()}`);
};

export const getStatusDistribution = async (year?: number): Promise<{ data: StatusDistribution }> => {
  const params = year ? `?year=${year}` : '';
  return await api.get(`/analytics/status-distribution${params}`);
};

export const getCompletionTimeAnalysis = async (year?: number): Promise<{ data: any[] }> => {
  const params = year ? `?year=${year}` : '';
  return await api.get(`/analytics/completion-time${params}`);
};

export const getMonthlyComparison = async (): Promise<{ data: any[] }> => {
  return await api.get('/analytics/monthly-comparison');
};

export const exportAnalyticsReport = async (format: 'xlsx' | 'csv' | 'pdf', year?: number): Promise<{ data: any }> => {
  return await api.post('/analytics/export', { format, year });
};